<template>
  <portal-layout>
    <div class="user-page">
      <div class="page-head">
        <h2 class="page-title">个人中心</h2>
      </div>

      <!-- 会员信息 -->
      <div class="member-card">
        <div class="member-avatar">
          <i class="el-icon-user-solid"></i>
        </div>
        <div class="member-info">
          <div class="member-name">{{ member.custName || member.mobile || '未登录' }}</div>
          <div v-if="member.mobile" class="member-mobile">{{ member.mobile }}</div>
        </div>
        <div class="member-action">
          <el-button v-if="member.id" size="small" @click="handleLogout">退出登录</el-button>
          <el-button v-else type="primary" size="small" @click="goLogin">立即登录</el-button>
        </div>
      </div>

      <!-- 功能入口 -->
      <div class="entry-card">
        <div class="entry-item" @click="goPage('/portal/order/list')">
          <i class="el-icon-tickets entry-icon"></i>
          <span class="entry-text">我的订单</span>
          <i class="el-icon-arrow-right entry-arrow"></i>
        </div>
        <div class="entry-item" @click="goPage('/portal/report/list')">
          <i class="el-icon-data-line entry-icon"></i>
          <span class="entry-text">学习报告</span>
          <i class="el-icon-arrow-right entry-arrow"></i>
        </div>
        <div class="entry-item" @click="goPage('/portal/user/student')">
          <i class="el-icon-user entry-icon"></i>
          <span class="entry-text">小主档案</span>
          <i class="el-icon-arrow-right entry-arrow"></i>
        </div>
        <div class="entry-item" @click="goPage('/portal/shop/car')">
          <i class="el-icon-shopping-cart-full entry-icon"></i>
          <span class="entry-text">购物车</span>
          <i class="el-icon-arrow-right entry-arrow"></i>
        </div>
        <div class="entry-item" @click="goPage('/portal/shop/favorite')">
          <i class="el-icon-star-off entry-icon"></i>
          <span class="entry-text">我的收藏</span>
          <i class="el-icon-arrow-right entry-arrow"></i>
        </div>
        <div class="entry-item" @click="goPage('/portal/shop/contact')">
          <i class="el-icon-service entry-icon"></i>
          <span class="entry-text">联系老师</span>
          <i class="el-icon-arrow-right entry-arrow"></i>
        </div>
      </div>
    </div>
  </portal-layout>
</template>
<script>
import PortalLayout from '@/components/PortalLayout.vue';
import api from '@/common/api';
import storage from '@/common/storage.js';

export default {
  name: 'PortalUserCenter',
  components: { PortalLayout },
  data() {
    return {
      member: {}
    }
  },
  created() {
    // 优先读 PortalLayout 已缓存的会员信息，避免重复请求
    const cached = storage.getString('portalMember');
    if (cached) {
      try {
        this.member = JSON.parse(cached);
        return;
      } catch (e) {
        this.member = {};
      }
    }
    api.current_member().then((r) => {
      if (r.data.code === "200" && r.data.data) {
        this.member = r.data.data;
      }
    }).catch(() => {
      // 未登录时静默处理，页面展示登录入口
    });
  },
  methods: {
    goLogin() {
      this.$router.push({ name: 'PortalLogin', query: { redirect: this.$route.fullPath } }).catch(() => {});
    },
    goPage(path) {
      if (!this.member.id) {
        this.$router.push({ name: 'PortalLogin', query: { redirect: path } }).catch(() => {});
        return;
      }
      this.$router.push(path).catch(() => {});
    },
    handleLogout() {
      api.logout().then(() => {
        this.member = {};
        storage.removeString('portalMember');
        storage.removeString('portalNoLogin');
        this.$message.success('已退出登录');
        this.$router.push('/portal/home').catch(() => {});
      }).catch(() => {});
    }
  }
};
</script>
<style scoped>
.page-head {
  margin-bottom: 20px;
}
.page-title {
  font-size: 22px;
  color: #303133;
  margin: 0;
}
.member-card {
  display: flex;
  align-items: center;
  background-color: #fff;
  border-radius: 8px;
  padding: 25px 30px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  margin-bottom: 20px;
}
.member-avatar {
  flex-shrink: 0;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background-color: #ecf5ff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
}
.member-avatar i {
  font-size: 32px;
  color: #409EFF;
}
.member-info {
  flex: 1;
}
.member-name {
  font-size: 18px;
  color: #303133;
  font-weight: 500;
}
.member-mobile {
  font-size: 13px;
  color: #909399;
  margin-top: 6px;
}
.entry-card {
  background-color: #fff;
  border-radius: 8px;
  padding: 5px 30px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}
.entry-item {
  display: flex;
  align-items: center;
  padding: 18px 0;
  border-bottom: 1px solid #ebeef5;
  cursor: pointer;
  transition: all 0.3s;
}
.entry-item:last-child {
  border-bottom: none;
}
.entry-item:hover .entry-text {
  color: #409EFF;
}
.entry-icon {
  font-size: 18px;
  color: #409EFF;
  width: 30px;
}
.entry-text {
  flex: 1;
  font-size: 15px;
  color: #303133;
}
.entry-arrow {
  font-size: 14px;
  color: #c0c4cc;
}
</style>
